import React from "react";
import PropTypes from "prop-types";
import HDFComponent from "./HDFComponent";
import withMatchMediaProps from "@hocs/with-match-media-props";

const Grid = ({ id, label, type, isNarrowScreen, columns, prefix, components, ...props }) => {
  return (
    <div
      className="grid-container"
      style={{ gridTemplateColumns: `repeat(${isNarrowScreen ? 1 : columns}, 1fr)` }}
    >
      {components &&
        components.map(comp => {
          return (
            <HDFComponent
              key={comp.id}
              comp={comp}
              name={prefix ? `${prefix}_${comp.id}` : comp.id}
              {...props}
            />
          );
        })}
    </div>
  );
};

Grid.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  prefix: PropTypes.string,
  medicalHistory: PropTypes.string,
  hideLabel: PropTypes.bool,
  isNarrowScreen: PropTypes.bool,
  columns: PropTypes.number,
  components: PropTypes.array,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(Grid);



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/components/Grid.js